import { render, staticRenderFns } from "./myCarousel.vue?vue&type=template&id=e4b3144e"
import script from "./myCarousel.vue?vue&type=script&lang=js"
export * from "./myCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports